import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class PhotoGrid {
  constructor(element) {
    this.element = element;
    this.items = this.element.querySelectorAll('.photo-grid__item');
    this.init();
  }

  init = () => {
    if (!this.items.length) return;

    gsap.set(this.items, { clipPath: 'inset(0% 0% 100% 0%)' });

    this.items.forEach((item) => {
      gsap.to(item, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: item,
          start: 'top 85%',
        },
      });
    });
  }
}
